import { useApi } from '@/api'

export const useBrandLogosResource = () => {
  const api = useApi()
  const brandOf = (organizationId: string, brandId: string) => api.api.v1.organizations({ organizationId }).brands({ brandId })
  const logoOf = (organizationId: string, brandId: string, slot: string) => brandOf(organizationId, brandId).logos({ slot })

  return {
    setBrandLogo: (organizationId: string, brandId: string, slot: string, body: Parameters<ReturnType<typeof logoOf>['put']>[0]) =>
      logoOf(organizationId, brandId, slot).put(body),
    setBrandLogoFile: (organizationId: string, brandId: string, slot: string, file: File) =>
      logoOf(organizationId, brandId, slot).file.post({ file }),
    delBrandLogo: (organizationId: string, brandId: string, slot: string) => logoOf(organizationId, brandId, slot).delete()
  }
}
